/* eslint-disable */
import React from 'react';
import { Box, Stack, Typography } from '@mui/material';
import { ReportEditor } from '../components/Reports/ReportEditor';

export const ReportsPage: React.FC = () => {
  return (
    <Box sx={{ pb: 3 }}>
      <Stack spacing={3}>
        <Box>
          <Typography variant="h4" gutterBottom>
            Reports
          </Typography>
          <Typography variant="body1" color="text.secondary">
            Generate, preview, and send release reports to Slack.
          </Typography>
        </Box>
        <Box>
          <ReportEditor />
        </Box>
      </Stack>
    </Box>
  );
};
